import { render } from "./commentsContainer.vue?vue&type=template&id=eac8b452&scoped=true&ts=true"
import script from "./commentsContainer.vue?vue&type=script&lang=ts"
export * from "./commentsContainer.vue?vue&type=script&lang=ts"

import "./commentsContainer.vue?vue&type=style&index=0&id=eac8b452&scoped=true&lang=css"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac8b452"]])

export default __exports__